import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getCountOnline = (params) => {
    return axios.get(`${backendHost}/api/admin/status/count`, {params});
};

export {
    getCountOnline
}